import { useMemo } from "react";
import { ReactSelectOptionValue } from "@/types/ReactSelectOptionValue";

const useBirthYearOptions = (): ReactSelectOptionValue<string>[] => {
  const options = useMemo<ReactSelectOptionValue<string>[]>(() => {
    const fullYear = new Date().getFullYear();
    const minYear = fullYear - 18; // 18歳より前は登録できないようにする

    return Array.from({ length: 100 }, (_, i) => minYear - i).map((value) => {
      return { label: String(value), value: String(value) };
    });
  }, []);

  return options;
};

export default useBirthYearOptions;
